<template>
  <div v-if="user && getImageUrl">
    <img class="profile-icon img-fluid rounded-circle" :src="getImageUrl" @click="$router.push({ path: '/profile' })">
  </div>
</template>

<script>
import backendUrl from '@/util/backendDetection';

export default {
  name: 'ProfileIcon',

  date() {
    return {
      user: null,
    };
  },

  created() {
    this.user = this.$store.getters.getUser;
    this.bindSubscription();
  },

  beforeDestroy() {
    this.destroySubscription();
  },

  computed: {
    getImageUrl() {
      if (this.user && this.user.profileImage && this.user.profileImage.container) {
        return `${backendUrl}/${this.user.profileImage.container}/${this.user.profileImage.name}`;
      }

      return null;
    },
  },

  methods: {
    bindSubscription() {
      this.destroySubscription = this.$store.subscribe((mutation) => {
        if (mutation.type === 'login') {
          this.user = this.$store.getters.getUser;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.profile-icon {
  &:hover {
    cursor: pointer;

  }
}
</style>
